<template>
  <v-container class="fill-height justify-center" fluid>
    
    <offline @detected-condition="handleConnectivityChange"> </offline>
    <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="deep-purple accent-4"></v-progress-linear>

    <v-form ref="form" v-model="valid" lazy-validation v-on:submit.prevent>
    <v-row align="center" justify="center">
      <v-col>
        <h1 class="ac mb20px blue--text">Create Enquiry</h1>
        <v-card tile>
          <v-card-text class="p30px">
            <h4 class="blue--text fs20px">Company Information</h4>
            <v-row>
              <v-col>
                <!-- <div class="mt20px">
                  <v-select v-model="model.assigned_to_id" :items="arrAssignedTo" label="Assigned To" :menu-props="{ offsetY: true }" outlined color="black"  required></v-select>
                </div> -->
                <div class="mt20px">
                  <v-select v-model="model.segment_id" :rules="segmentRules" :items="arrSegment" label="Segment" :menu-props="{ offsetY: true }" outlined color="black" ></v-select>
                </div>
                <div class="mt20px">
                  <v-autocomplete v-model="model.group_id" :items="arrGroup" item-text="name" label="Group" outlined color="black" ></v-autocomplete>
                </div>
                <div class="mt20px">
                  <v-select v-model="model.event_type_id" :items="items" label="Event Type" :menu-props="{ offsetY: true }" outlined color="black" required></v-select>
                </div>
              </v-col>

              <v-col>
                <div class="d-flex mt20px">
                  <v-autocomplete v-model="model.company_id" :items="arrCompany" item-text="name" label="Company / Individual Name" outlined color="black" ></v-autocomplete>

                  <!-- <v-dialog v-model="dialog" persistent max-width="800" overlay-opacity="0.8">
                    <template v-slot:activator="{ on }">
                      <v-btn dark x-large tile depressed class="icon-only ml10px" v-on="on"><v-icon>mdi-plus</v-icon></v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <div class="headline bold"><strong>Add New Company</strong></div>
                        <v-spacer></v-spacer>
                        <v-btn text icon color="black" @click="dialog = false">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col>
                            <div>
                              <v-text-field v-model="model.name" label="Company / Individual Name" color="black" outlined ></v-text-field>
                            </div>
                            <div class="mt20px">
                              <v-text-field v-model="model.mobile" label="Mobile" color="black" outlined ></v-text-field>
                            </div>
                            <div class="mt20px">
                              <v-text-field v-model="model.email" label="Email" color="black" outlined ></v-text-field>
                            </div>
                          </v-col>

                          <v-col>
                            <div>
                              <v-select v-model="model.client_ref" :items="arrCustomerRef" label="Customer's Ref" :menu-props="{ offsetY: true }" outlined color="black" ></v-select>
                            </div>
                            <div class="mt20px">
                              <v-select v-model="model.state_id" :items="arrState" label="State" :menu-props="{ offsetY: true }" outlined color="black" ></v-select>
                            </div>
                            <div class="mt20px">
                              <v-select v-model="model.city_id" :items="arrCity" label="City" :menu-props="{ offsetY: true }" outlined color="black" ></v-select>
                            </div>
                          </v-col>
                        </v-row>
                        <v-btn dark x-large tile depressed color="black" class="text-capitalize fw300 w100 mt10px">Save Company</v-btn>
                      </v-card-text>
                    </v-card>
                  </v-dialog> -->
                </div>
                <div class="d-flex mt20px">
                  <v-autocomplete v-model="model.contact_person_id" :items="arrContacts" item-text="name" label="Contact Person" outlined color="black" ></v-autocomplete>

                  <!-- <v-dialog v-model="dialog2" persistent max-width="500" overlay-opacity="0.8">
                    <template v-slot:activator="{ on }">
                      <v-btn dark x-large tile depressed class="icon-only ml10px" v-on="on"><v-icon>mdi-plus</v-icon></v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <div class="headline bold"><strong>Add New Contact Person</strong></div>
                        <v-spacer></v-spacer>
                        <v-btn text icon color="black" @click="dialog2 = false">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-card-text>
                        <div>
                          <v-text-field v-model="model.name" label="Contact Person Name" color="black" outlined ></v-text-field>
                        </div>
                        <div class="mt20px">
                          <v-text-field v-model="model.mobile" label="Mobile" color="black" outlined ></v-text-field>
                        </div>
                        <div class="mt20px">
                          <v-text-field v-model="model.email" label="Email" color="black" outlined ></v-text-field>
                        </div>
                        <v-btn dark x-large tile depressed color="black" class="text-capitalize fw300 w100 mt20px">Save Contact Person</v-btn>
                      </v-card-text>
                    </v-card>
                  </v-dialog> -->
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card tile class="mt20px">
          <v-card-text class="p30px">
            <h4 class="blue--text fs20px">Contact Information</h4>
            <v-row>
              <v-col>
                <div class="mt20px">
                  <v-text-field v-model="model.address_line1" label="Address Line 1" outlined color="black" ></v-text-field>
                </div>
                <div class="mt20px">
                  <v-text-field v-model="model.address_line2" label="Address Line 2" outlined color="black" ></v-text-field>
                </div>
                <div class="mt20px">
                  <v-text-field v-model="model.address_line3" label="Address Line 3" outlined color="black" ></v-text-field>
                </div>
                <div class="mt20px">
                  <v-select v-model="model.country_id" :items="items" label="Country" :menu-props="{ offsetY: true }" outlined color="black" ></v-select>
                </div>
                <div class="mt20px">
                  <v-select v-model="model.state_id" :items="arrState" label="State" :menu-props="{ offsetY: true }" outlined color="black" ></v-select>
                </div>
                <div class="mt20px">
                  <v-select v-model="model.city_id" :items="arrCity" label="City" :menu-props="{ offsetY: true }" outlined color="black" ></v-select>
                </div>
              </v-col>

              <v-col>
                <div class="mt20px">
                  <v-text-field v-model="model.pincode" label="Pincode" outlined color="black" ></v-text-field>
                </div>
                <div class="mt20px">
                  <v-text-field v-model="model.mobile" label="Mobile" outlined color="black" ></v-text-field>
                </div>
                <div class="mt20px">
                  <v-text-field v-model="model.email" label="Email" outlined color="black" ></v-text-field>
                </div>
                <div class="mt20px">
                  <v-text-field v-model="model.tel_fax" label="Tel/Fax" outlined color="black" ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card tile class="mt20px">
          <v-card-text class="p30px">
            <h4 class="blue--text fs20px">Other Information</h4>
            <v-row>
              <v-col>
                <div class="mt20px">
                  <v-textarea v-model="model.remark" label="Remark" outlined color="black" ></v-textarea>
                </div>
                <!-- <div class="mt20px">
                  <v-select v-model="model.enquiry_type" :items="arrEnquiryType" label="Type Of Enquiry" :menu-props="{ offsetY: true }" outlined color="black" ></v-select>
                </div> -->
              </v-col>

              <v-col>
                <!-- <div class="mt20px">
                  <v-select v-model="model.status" :items="arrStatus" label="Status" :menu-props="{ offsetY: true }" outlined color="black" ></v-select>
                </div> -->
                <div class="mt20px">
                  <v-menu ref="menu" v-model="model.menu" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="model.date" label="Date" append-icon="mdi-calendar" readonly outlined color="black"  v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="model.date" no-title scrollable color="black">
                      <v-spacer></v-spacer>
                      <v-btn text color="grey" @click="menu = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <div class="mx-auto mt30px ac" tile>
          <v-btn @click="validate"  color="primary" dark x-large tile depressed class="text-capitalize fw300 min-width btn-big">Save Enquiry</v-btn>
          <!-- <v-btn color="black" dark x-large tile depressed class="text-capitalize fw300 m10px">Cancel</v-btn> -->
        </div>
      </v-col>
    </v-row>
     </v-form>

     <v-snackbar v-model="snackbar" :multi-line="true" :bottom="true" :left="true">
      {{ snackbarText }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import offline from "v-offline";
import api from "@/api";

export default {
  name: "Home",
  components: {
    offline
  },
  data: () => ({
    valid: true,
    segmentRules: [v => !!v || "Segment is required"],
    connectionStatus: false,
    model: {},
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    dialog: false,
    dialog2: false,
    loading: false,
    arrCompany: [{ name: "Stefab" }, { name: "Momentum Software" }, { name: "Edupaytion" }],
    arrContacts: [{ name: "Zehan A" }, { name: "Varun B" }, { name: "Gurpreet S" }, { name: "Tavinder S" }],
    arrCity: ["Delhi", "Chandigarh", "Mumbai"],
    arrState: ["Delhi", "Maharashtra", "Uttar Pradesh"],
    arrGroup: ["Group 1", "Group 2", "Group 3", "Group 4"],
    arrEnquiryType: ["New", "Unassigned"],
    arrStatus: ["Pending", "Completed"],
    arrCustomerRef: ["Ref 1", "Ref 2", "Ref 3", "Ref 4"],

    arrAssignedTo: ["Nikita", "Rajesh", "Anil"],
    arrSegment: ["Segment 1", "Segment 2", "Segment 3", "Segment 4"],

    items: ["Option 1", "Option 2", "Option 3", "Option 4"],
    groups: [{ name: "Option 1" }, { name: "Option 2" }, { name: "Option 3" }],
    snackbar: false,
    snackbarText: ""
  }),
  async created() {
    this.refresh();
  },
  methods: {

     validate() {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    reset() {
      this.$refs.form.reset();
    },

    resetValidation() {
      this.$refs.form.resetValidation();
    },

    async submitForm() {
      //alert(this.connectionStatus);
      let objResponse = await api.processEnquiry(this.connectionStatus, this.model);
      console.log("objResponse is", objResponse);

      if (objResponse.blnOk) {
        if(!this.connectionStatus){
            this.openSnackBar("Enquiry SAVED successfully!");
        }else {
           this.openSnackBar("Enquiry POSTED successfully!");
        }
        window.location.href = "/thankyou";
        //this.$router.push({ path: "thankyou" });
      } else {
        this.openSnackBar(objResponse.msg);
      }
    },

    async refresh() {
      this.loading = true;

      /*
      load default arrays and populate here
      let objResnpose = await api.getEnquiryDefaults();
      */
      this.loading = false;
    },

    handleConnectivityChange(status) {
      this.connectionStatus = status;
      console.log("this.connectionStatus is", this.connectionStatus);
    },
     openSnackBar(str) {
      this.snackbarText = str;
      this.snackbar = true;
    }
  }
};
</script>
